(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    

(() => {
  const states = new WeakMap();
  function initialize(section) {
    if (states.has(section)) return;
    const tabs = [...section.querySelectorAll('[role="tab"]')];
    const panels = [...section.querySelectorAll('[role="tabpanel"]')];
    const controller = new AbortController();
    const observers = [];
    const signal = controller.signal;
    const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
    function hydrate(panel) {
      const template = panel.querySelector('template[data-psi-featured-template]');
      if (template) template.replaceWith(template.content.cloneNode(true));
      panel.querySelectorAll('[data-featured-carousel]').forEach(carousel => {
        if (carousel.dataset.carouselReady) return;
        carousel.dataset.carouselReady = 'true';
        const track = carousel.querySelector('[data-carousel-track]');
        const previous = carousel.querySelector('[data-carousel-previous]');
        const next = carousel.querySelector('[data-carousel-next]');
        const update = () => {
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= Math.max(0, track.scrollWidth - track.clientWidth) - 2;
        };
        const scroll = direction => {
          track.scrollBy({left:direction * track.clientWidth,behavior:reducedMotion() ? 'auto' : 'smooth'});
        };
        previous.addEventListener('click', () => scroll(-1), {signal});
        next.addEventListener('click', () => scroll(1), {signal});
        let frame = 0;
        track.addEventListener('scroll', () => {
          if (frame) return;
          frame = requestAnimationFrame(() => {frame = 0; update();});
        }, {passive:true,signal});
        signal.addEventListener('abort', () => cancelAnimationFrame(frame), {once:true});
        const observer = new ResizeObserver(update);
        observer.observe(track);
        observers.push(observer);
        update();
      });
    }
    function activate(index, focus = false) {
      tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('active',active);
        tab.setAttribute('aria-selected',String(active));
        tab.tabIndex = active ? 0 : -1;
        panels[i].classList.toggle('active',active);
        panels[i].hidden = !active;
      });
      hydrate(panels[index]);
      if (focus) tabs[index].focus();
    }
    tabs.forEach((tab,index) => {
      tab.addEventListener('click', () => activate(index), {signal});
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        activate(next,true);
      }, {signal});
    });
    if (tabs.length) activate(Math.max(0,tabs.findIndex(t=>t.classList.contains('active'))));
    states.set(section, () => {
      controller.abort();
      observers.forEach(observer => observer.disconnect());
      states.delete(section);
    });
  }
  const sections = root => {
    const result = [...root.querySelectorAll('[data-psi-featured]')];
    if (root.matches?.('[data-psi-featured]')) result.unshift(root);
    return result;
  };
  const load = root => sections(root).forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>load(document),{once:true});
  else load(document);
  document.addEventListener('shopify:section:load',event=>load(event.target));
  document.addEventListener('shopify:section:unload',event=>sections(event.target).forEach(section=>states.get(section)?.()));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psi-box-configurator"] && !Shopify.designMode) return;
  try {
    
(function(){
  function money(value){return new Intl.NumberFormat('it-IT',{style:'currency',currency:'EUR'}).format(Number(value||0));}
  function init(root){
    if(root.dataset.ready==='true')return;
    root.dataset.ready='true';
    var data=JSON.parse(root.querySelector('[data-box-json]').textContent);
    var labels={choose:root.dataset.choose,from:root.dataset.from,backColors:root.dataset.backColors,backModels:root.dataset.backModels,backCompositions:root.dataset.backCompositions,selectSizes:root.dataset.selectSizes,selected:root.dataset.selected,lookupError:root.dataset.lookupError,minError:root.dataset.minError,cartError:root.dataset.cartError,cartLoading:root.dataset.cartLoading,cartAdd:root.dataset.cartAdd,skuLabel:root.dataset.skuLabel};
    var colorOrder=['Azzurro/Blu','Rosso/Blu','Giallo/Blu','Blu/Bianco','Granata/Nero','Verde/Nero','Nero/Giallo','Nero/Bianco'];
    var colorGrid=root.querySelector('[data-color-grid]');
    var modelGrid=root.querySelector('[data-model-grid]');
    var compositionGrid=root.querySelector('[data-composition-grid]');
    var componentsEl=root.querySelector('[data-components]');
    var summary=root.querySelector('[data-summary]');
    var status=root.querySelector('[data-status]');
    var cartButton=root.querySelector('[data-add-cart]');
    var printButton=root.querySelector('[data-box-print]');
    var dialog=root.querySelector('[data-size-dialog]');
    var dialogTitle=root.querySelector('[data-dialog-title]');
    var dialogSku=root.querySelector('[data-dialog-sku]');
    var dialogImage=root.querySelector('[data-dialog-image]');
    var sizeList=root.querySelector('[data-size-list]');
    var dialogStatus=root.querySelector('[data-dialog-status]');
    var state={color:null,model:null,variant:null,selections:{},activeComponent:null,activeProduct:null};
    /* v435 — visore e barra. ORDINE e' l'unica fonte della numerazione "N/4":
       il titolo e il contatore del passo si ricavano da qui, non sono scritti a mano. */
    var viewerImage=root.querySelector('[data-viewer-image]');
    var navPrev=root.querySelector('[data-nav-prev]');
    var navNext=root.querySelector('[data-nav-next]');
    var stepTitle=root.querySelector('[data-step-title]');
    var stepCount=root.querySelector('[data-step-count]');
    var doneButton=root.querySelector('[data-box-done]');
    var ORDINE=['color','model','composition','sizes'];
    var TITOLI={color:root.dataset.stepColor,model:root.dataset.stepModel,composition:root.dataset.stepComposition,sizes:root.dataset.stepSizes};
    var stageCorrente='color';
    /* I nomi colore del catalogo Givova sono composti: "Azzurro/Blu". La pastiglia
       mostra i due colori a meta' e meta', quindi la tavolozza traduce le parole
       una per una. Un nome non previsto resta grigio invece di sparire. */
    var TAVOLOZZA={azzurro:'#3aa0e0',blu:'#12306e',rosso:'#d92820',giallo:'#f2c500',bianco:'#ffffff',granata:'#7a1220',nero:'#141414',verde:'#0f8f4a',arancio:'#f07f13',rosa:'#e2649a',celeste:'#7cc7ef',grigio:'#9a9a9a',fucsia:'#d81b7a'};
    function tinte(nome){
      var parti=String(nome||'').split('/').map(function(x){return TAVOLOZZA[x.trim().toLowerCase()]||'#b9b9b9';});
      if(parti.length===1)parti.push(parti[0]);
      return parti;
    }
    /* v442 — PRECARICO. Cambiare foto significa cambiare src: se il file non e' gia'
       nella cache del browser, fra il tocco e l'immagine passa il tempo della rete.
       Quindi appena si entra in un passo si scaricano in silenzio tutte le foto che
       quel passo puo' mostrare: i quattro modelli, le quattro composizioni, gli otto
       colori. Al tocco l'immagine e' gia' pronta e il cambio non ha attesa. */
    /* v446 — LE FOTO NON SI MUOVONO PIU'.
       Il riquadro era gia' fisso, ma il contenuto no: Givova inquadra i capi in modo
       leggermente diverso in ogni scatto. Misurate tutte e 111 le foto, il centro del
       contenuto si sposta fino al 3,2% in larghezza e al 3,1% in altezza, e la
       grandezza varia del 4%: e' quel tremolio che si vede cambiando colore.
       Per ogni foto il campo "b" nei dati dice dove sta il contenuto: centro x, centro
       y, larghezza e altezza, in frazioni dell'immagine. Qui si usa per ingrandire e
       spostare la foto quel tanto che serve a far cadere il contenuto sempre nello
       stesso punto. Cambia l'interno, la cornice resta ferma. */
    var riquadri={};
    data.forEach(function(m){m.variants.forEach(function(v){if(v.image&&v.b)riquadri[v.image]=v.b;});});
    /* v449 — INGRANDIMENTO UNICO PER TUTTE.
       Prima ogni foto veniva ingrandita quanto serviva a far riempire il riquadro al
       suo contenuto. Ma i box non hanno tutti lo stesso numero di capi: quelli con
       meno pezzi venivano zoomati di piu' e i capi cambiavano grandezza passando da un
       modello all'altro. Era quello a dare ancora la sensazione di movimento.
       Ora lo zoom e' UNO SOLO per tutte — calcolato sulla misura mediana delle 111
       foto — e per ogni foto si corregge soltanto lo spostamento del centro. Quindi
       i capi restano della stessa grandezza e cadono nello stesso punto. */
    var mediana=(function(){
      var lw=[],lh=[];
      for(var k in riquadri){lw.push(riquadri[k][2]);lh.push(riquadri[k][3]);}
      function med(a){a.sort(function(x,y){return x-y;});return a.length?a[Math.floor(a.length/2)]:1;}
      return [med(lw),med(lh)];
    }());
    function normalizza(src){
      var b=riquadri[src];
      if(!viewerImage)return;
      if(!b){viewerImage.style.transform='';return;}
      var W=viewerImage.clientWidth,H=viewerImage.clientHeight;
      if(!W||!H)return;
      var r=(viewerImage.naturalWidth&&viewerImage.naturalHeight)?viewerImage.naturalWidth/viewerImage.naturalHeight:1.9162;
      var Wp=Math.min(W,H*r),Hp=Wp/r,ox=(W-Wp)/2,oy=(H-Hp)/2;
      var s=Math.min((W*0.99)/(mediana[0]*Wp),(H*0.98)/(mediana[1]*Hp));
      var cx=ox+b[0]*Wp,cy=oy+b[1]*Hp;
      viewerImage.style.transform='translate('+(-s*(cx-W/2)).toFixed(1)+'px,'+(-s*(cy-H/2)).toFixed(1)+'px) scale('+s.toFixed(4)+')';
    }
    var precaricate={};
    function precarica(urls){
      urls.forEach(function(u){
        if(!u||precaricate[u])return;
        precaricate[u]=new Image();
        precaricate[u].decoding='async';
        precaricate[u].src=u;
      });
    }
    /* v442 — Cambio foto senza buco. Se il file e' gia' in cache (quasi sempre, grazie
       al precarico) lo scambio avviene nello stesso istante del tocco. Se per qualche
       motivo non lo fosse, si continua a vedere la foto precedente finche' la nuova
       non e' pronta, invece di lasciare un riquadro vuoto. */
    function setViewer(src,alt){
      if(!viewerImage||!src)return;
      if(viewerImage.getAttribute('src')===src){viewerImage.alt=alt||'';normalizza(src);return;}
      var pronta=precaricate[src];
      if(pronta&&pronta.complete&&pronta.naturalWidth>0){viewerImage.src=src;viewerImage.alt=alt||'';normalizza(src);return;}
      var attesa=pronta||new Image();
      if(!pronta){precaricate[src]=attesa;attesa.src=src;}
      var chiusa=false;
      function mostra(){if(chiusa)return;chiusa=true;if(viewerImage.dataset.atteso===src){viewerImage.src=src;viewerImage.alt=alt||'';normalizza(src);}}
      viewerImage.dataset.atteso=src;
      if(attesa.complete&&attesa.naturalWidth>0){mostra();return;}
      attesa.addEventListener('load',mostra,{once:true});
      attesa.addEventListener('error',function(){if(viewerImage.dataset.atteso===src){viewerImage.src=src;viewerImage.alt=alt||'';}},{once:true});
    }
    /* Dopo una scelta: l'utente resta dov'e' (aggiorno solo frecce e didascalia),
       il deeplink va avanti. Vedi la nota nel gestore dei click. */
    function aggiorna(event,prossimo){
      if(event&&event.isTrusted===false){setStage(prossimo);return;}
      setStage(stageCorrente);
    }
    function segnaScelta(action,value){
      root.querySelectorAll('[data-action="'+action+'"]').forEach(function(el){
        el.classList.toggle('is-selected',el.dataset.value===value);
        el.setAttribute('aria-pressed',el.dataset.value===value?'true':'false');
      });
    }
    var productCache={};

    function setStage(name){
      stageCorrente=name;
      root.querySelectorAll('[data-stage]').forEach(function(el){el.hidden=el.dataset.stage!==name;});
      root.dataset.stageAttivo=name;
      var indice=ORDINE.indexOf(name);
      if(stepTitle)stepTitle.textContent=TITOLI[name]||'';
      if(stepCount)stepCount.textContent=(indice+1)+'/'+ORDINE.length;
      /* La freccia sinistra e' attiva se il passo ha un [data-back]: il ritorno resta
         gestito da quel pulsante, qui non si duplica niente.
         La destra e' attiva solo se in questo passo una scelta e' gia' stata fatta,
         perche' andare avanti significa confermarla. */
      var stage=root.querySelector('[data-stage="'+name+'"]');
      if(navPrev)navPrev.disabled=!(stage&&stage.querySelector('[data-back]'));
      var scelto=!!(stage&&stage.querySelector('.is-selected'));
      if(navNext)navNext.disabled=!scelto;
      /* v439 — il pulsante in fondo c'e' SEMPRE, stessa misura e stesso posto: nei
         primi tre passi e' Continua (spento finche' non scegli), al quarto e' il
         carrello. Niente elementi che compaiono o spariscono: era quello a far
         cambiare altezza alla barra. */
      var continua=root.querySelector('[data-nav-continue]');
      if(continua){continua.hidden=(name==='sizes');continua.disabled=!scelto;}
      if(cartButton)cartButton.hidden=(name!=='sizes');
      /* Al passo taglie serve tutto lo spazio: la tendina si apre alzata del tutto,
         e resta solo la riga con "..." e Fine. Negli altri passi torna alla misura
         normale, uguale per tutti e tre. */
      poni(name==='sizes'?2:0);
    }
    /* v435 — al posto delle card con foto: pastiglia bicolore per il colore,
       pillola con nome e prezzo per modello e composizione. La foto non sta piu'
       nel pulsante, sta nel visore: ogni pulsante la porta in data-image e il
       gestore dei click la passa a setViewer. */
    function card(image,title,meta,action,value){
      var button=document.createElement('button');
      button.type='button';button.dataset.action=action;button.dataset.value=value;
      button.dataset.image=image||'';button.setAttribute('aria-pressed','false');
      if(action==='color'){
        button.className='psibox__swatch';
        button.setAttribute('aria-label',title);
        button.title=title;
        var c=tinte(title);
        var disco=document.createElement('span');
        disco.className='psibox__swatch-disc';
        disco.style.background='linear-gradient(90deg,'+c[0]+' 0 50%,'+c[1]+' 50% 100%)';
        button.appendChild(disco);
        return button;
      }
      button.className='psibox__chip';
      var strong=document.createElement('strong');strong.textContent=title;
      button.appendChild(strong);
      if(meta&&meta!==labels.choose){var span=document.createElement('span');span.textContent=meta;button.appendChild(span);}
      return button;
    }
    function allVariants(){return data.reduce(function(list,model){return list.concat(model.variants.map(function(v){return{model:model,variant:v};}));},[]);}
    function renderColors(){
      colorGrid.innerHTML='';
      var prima=null;
      colorOrder.forEach(function(color){
        var match=allVariants().find(function(item){return item.variant.color===color;});
        if(!match)return;
        if(!prima)prima=match;
        colorGrid.appendChild(card(match.variant.image,color,labels.choose,'color',color));
      });
      /* Il visore non parte mai vuoto: senza una scelta mostra la prima combinazione
         disponibile, cosi' la sezione si apre gia' con un prodotto in pagina. */
      if(prima&&!state.color)setViewer(prima.variant.image,prima.model.name+' '+prima.variant.color);
      precarica(Array.prototype.map.call(colorGrid.children,function(b){return b.dataset.image;}));
    }
    function renderModels(){
      modelGrid.innerHTML='';
      data.forEach(function(model){
        var variants=model.variants.filter(function(v){return v.color===state.color;});
        if(!variants.length)return;
        var min=Math.min.apply(null,variants.map(function(v){return Number(v.price);}));
        modelGrid.appendChild(card(variants[0].image,model.name.replace(/^Box\s+/i,''),labels.from+' '+money(min),'model',model.key));
        precarica([variants[0].image]);
      });
      root.querySelector('[data-model-title]').textContent=state.color;
      root.querySelector('[data-back="color"]').textContent=labels.backColors;
    }
    function renderCompositions(){
      compositionGrid.innerHTML='';
      var variants=state.model.variants.filter(function(v){return v.color===state.color;});
      variants.forEach(function(v){compositionGrid.appendChild(card(v.image,v.composition,money(v.price),'composition',v.sku));});precarica(variants.map(function(v){return v.image;}));
      root.querySelector('[data-composition-title]').textContent=state.model.name+' — '+state.color;
      root.querySelector('[data-back="model"]').textContent=labels.backModels;
    }
    function selectionTotal(sku){
      var values=state.selections[sku]||{};return Object.keys(values).reduce(function(sum,id){return sum+Number(values[id]||0);},0);
    }
    function refreshCartState(){
      if(!state.variant){cartButton.disabled=true;return;}
      var invalid=state.variant.components.some(function(component){return selectionTotal(component.sku)<1;});
      cartButton.disabled=invalid;
      if(!invalid)status.textContent='';
    }
    function renderComponents(savedSelections){
      state.selections=savedSelections||{};componentsEl.innerHTML='';
      /* v439 — riepilogo su una riga: la foto e' nel visore sopra, ripeterla qui
         mangiava l'altezza della barra. Nome della combinazione + prezzo. */
      summary.textContent=state.model.name+' · '+state.color+' · '+state.variant.composition;
      var prezzo=document.createElement('strong');prezzo.className='psibox__summary-price';prezzo.textContent=money(state.variant.price);
      summary.append(' ',prezzo);
      state.variant.components.forEach(function(component){
        var row=document.createElement('article');row.className='psibox__component';row.dataset.componentSku=component.sku;
        var media=document.createElement('div');media.className='psibox__component-media';var thumb=document.createElement('img');thumb.loading='lazy';thumb.alt=component.name||component.sku;thumb.hidden=true;media.appendChild(thumb);
        var text=document.createElement('div');text.className='psibox__component-info';var h=document.createElement('h4');h.textContent=component.name||component.sku;var sku=document.createElement('p');sku.textContent=labels.skuLabel+' '+component.sku;var priceEl=document.createElement('p');priceEl.hidden=true;var selected=document.createElement('p');selected.className='psibox__selected';selected.dataset.selectedFor=component.sku;selected.textContent=labels.selected.replace('__count__',String(selectionTotal(component.sku)));text.append(h,sku,priceEl,selected);
        var btn=document.createElement('button');btn.type='button';btn.dataset.selectSku=component.sku;btn.textContent=labels.selectSizes;row.append(media,text,btn);componentsEl.appendChild(row);
        loadProduct(component).then(function(product){component.name=product.title;component.image=product.image||component.image;h.textContent=product.title;thumb.alt=product.title;if(component.image){thumb.src=component.image;thumb.hidden=false;}var prices=product.variants.map(function(v){return Number(v.price||0)/100;}).filter(function(v){return v>0;});if(prices.length){component.price=Math.min.apply(Math,prices);priceEl.textContent=money(component.price);priceEl.hidden=false;}}).catch(function(){priceEl.hidden=true;});
      });
      root.querySelector('[data-back="composition"]').textContent=labels.backCompositions;refreshCartState();
    }
    async function loadProduct(component){
      if(productCache[component.sku])return productCache[component.sku];
      var base=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';var sku=component.sku.toUpperCase();var variants=[];var seen={};var image=component.image||'';
      for(var i=0;i<(component.handles||[]).length;i++){
        var response=await fetch(base+'products/'+component.handles[i]+'.js',{headers:{Accept:'application/json'}});
        if(!response.ok)continue;var product=await response.json();
        product.variants.forEach(function(v){var value=String(v.sku||'').toUpperCase();if((value===sku||value.indexOf(sku+'-')===0)&&!seen[value]){seen[value]=true;variants.push(v);if(!image&&v.featured_image&&v.featured_image.src)image=v.featured_image.src;}});
        if(!image&&product.featured_image)image=product.featured_image;
      }
      if(!variants.length)throw new Error('not-found');
      var result={title:component.name||component.sku,image:image,variants:variants};productCache[component.sku]=result;return result;
    }
    async function openSizes(component){
      state.activeComponent=component;dialogTitle.textContent=component.name||component.sku;dialogSku.textContent=labels.skuLabel+' '+component.sku;dialogImage.hidden=true;if(component.image){dialogImage.src=component.image;dialogImage.alt=component.name||component.sku;dialogImage.hidden=false;}dialogStatus.textContent='';sizeList.innerHTML='';dialog.showModal();/* v446 — all'apertura il browser mette il fuoco sul primo pulsante, cioe' la x, e la disegna con l'alone azzurro. Lo togliamo subito: il fuoco resta comunque raggiungibile da tastiera. */var xChiudi=dialog.querySelector('.psibox__dialog-close');if(xChiudi&&xChiudi.blur)xChiudi.blur();
      try{
        var product=await loadProduct(component);state.activeProduct=product;component.name=product.title;component.image=product.image||component.image;dialogTitle.textContent=product.title;if(component.image){dialogImage.src=component.image;dialogImage.alt=product.title;dialogImage.hidden=false;}
        var sizeOrder=['7XS','6XS','5XS','4XS','3XS','2XS','XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL','7XL','JUNIOR','SENIOR','UNICA'];
        function sizeKey(v){var title=String(v.public_title||v.title||'').toUpperCase();var parts=title.split('/');return parts[parts.length-1].trim();}
        var orderedVariants=product.variants.filter(function(v){return v.available;}).sort(function(a,b){var ak=sizeKey(a),bk=sizeKey(b),ai=sizeOrder.indexOf(ak),bi=sizeOrder.indexOf(bk);if(ai<0)ai=999;if(bi<0)bi=999;return ai-bi||ak.localeCompare(bk,'it',{numeric:true});});
        sizeList.style.setProperty('--psi-size-count',String(Math.max(1,orderedVariants.length)));
        orderedVariants.forEach(function(v){
          var row=document.createElement('label');row.className='psibox__size';var name=document.createElement('strong');name.className='psibox__size-name';/* v441 — solo la taglia: il colore e' gia' scritto in cima al foglio, ripeterlo su ogni riga ("GRANATA/NERO / 4XS") allunga e non aggiunge nulla. */name.textContent=sizeKey(v)||v.public_title||v.title;
          var input=document.createElement('input');input.type='number';input.min='0';input.step='1';input.inputMode='numeric';input.pattern='[0-9]*';input.enterKeyHint='done';input.autocomplete='off';input.setAttribute('aria-label','Quantità '+(v.public_title||v.title));input.dataset.variantId=String(v.id);input.value=String((state.selections[component.sku]||{})[v.id]||0);row.append(name,input);sizeList.appendChild(row);
        });
        if(!sizeList.children.length)throw new Error('unavailable');
      }catch(error){dialogStatus.textContent=labels.lookupError;}
    }
    function applySizes(){
      if(!state.activeComponent)return;var values={};sizeList.querySelectorAll('[data-variant-id]').forEach(function(input){var quantity=Math.max(0,Math.floor(Number(input.value||0)));if(quantity>0)values[input.dataset.variantId]=quantity;});
      state.selections[state.activeComponent.sku]=values;var total=selectionTotal(state.activeComponent.sku);
      var selected=root.querySelector('[data-selected-for="'+CSS.escape(state.activeComponent.sku)+'"]');if(selected)selected.textContent=labels.selected.replace('__count__',String(total));
      if(total<1){dialogStatus.textContent=labels.minError.replace('__count__',String(total));return;}
      dialog.close();refreshCartState();
    }
    function draft(){
      if(!state.model||!state.variant)return null;
      return{version:1,color:state.color,model:state.model.key,variant:state.variant.sku,selections:state.selections,savedAt:new Date().toISOString()};
    }
    function draftText(value){
      if(!value)return '';
      var model=data.find(function(item){return item.key===value.model;});
      var variant=model&&model.variants.find(function(item){return item.sku===value.variant;});
      if(!model||!variant)return '';
      var lines=['Configurazione Planet Sport Italia',model.name+' — '+value.color+' — '+variant.composition,'Codice: '+variant.sku];
      variant.components.forEach(function(component){
        var selected=(value.selections||{})[component.sku]||{};
        var total=Object.keys(selected).reduce(function(sum,id){return sum+Number(selected[id]||0);},0);
        lines.push((component.name||component.sku)+': '+total+' pezzi');
      });
      return lines.join('\n');
    }
    function restoreDraft(value){
      if(!value||value.version!==1)return false;
      var model=data.find(function(item){return item.key===value.model;});
      var variant=model&&model.variants.find(function(item){return item.sku===value.variant&&item.color===value.color;});
      if(!model||!variant)return false;
      state.color=value.color;state.model=model;state.variant=variant;
      renderComponents(value.selections||{});
      setStage('sizes');
      status.textContent='Configurazione ripristinata.';
      return true;
    }
    function storageAllowed(){
      var privacy=window.Shopify&&window.Shopify.customerPrivacy;
      return !privacy||typeof privacy.preferencesProcessingAllowed!=='function'||privacy.preferencesProcessingAllowed();
    }
    /* v444 — Qui c'erano saveDraft, shareUrl, shareDraft e whatsappDraft, cioe' i tre
       comandi del menu "..." (salva sul dispositivo, condividi link, invia su
       WhatsApp). Rimossi con i loro pulsanti: restano il preventivo e il carrello.
       restoreDraft e storageAllowed restano perche' servono ancora al ripristino di
       una configurazione aperta da un link con #box=. */
    /* La notifica del sito: stessa forma di #cart-notification del tema (fascia in
       basso che sale, filetto rosso a sinistra), ricreata qui perche' il layout a
       schermo pieno non monta il carrello a scomparsa. */
    var toast=root.querySelector('[data-toast]');
    var toastText=root.querySelector('[data-toast-text]');
    var toastLink=root.querySelector('[data-toast-link]');
    var toastTimer;
    function avvisa(testo,dove){
      if(!toast)return;
      if(toastText)toastText.textContent=testo;
      if(toastLink&&dove)toastLink.setAttribute('href',dove);
      toast.classList.add('is-visibile');
      clearTimeout(toastTimer);
      toastTimer=setTimeout(function(){toast.classList.remove('is-visibile');},5000);
    }
    async function addToCart(){
      refreshCartState();if(cartButton.disabled){status.textContent=labels.minError.replace('__count__','0');return;}
      cartButton.disabled=true;cartButton.textContent=labels.cartLoading;var group='BOX-'+Date.now();var items=[];
      state.variant.components.forEach(function(component){var chosen=state.selections[component.sku]||{};Object.keys(chosen).forEach(function(id){items.push({id:Number(id),quantity:Number(chosen[id]),properties:{'_psi_box_group':group,'Box':state.model.name,'Colore':state.color,'Composizione':state.variant.composition}});});});
      try{
        var base=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';var response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
        if(!response.ok)throw new Error('cart');
        /* v453 — Prima si veniva sbattuti sulla pagina carrello: sembrava un errore.
           Ora si resta nel configuratore e sale dal basso la notifica del sito, con il
           collegamento al carrello. Il pulsante torna disponibile: si puo' aggiungere
           un secondo BOX cambiando colore o taglie. */
        var pezzi=items.reduce(function(t,i){return t+i.quantity;},0);
        avvisa(pezzi===1?'1 articolo aggiunto al carrello':pezzi+' articoli aggiunti al carrello',base+'cart');
        cartButton.disabled=false;cartButton.textContent=labels.cartAdd;
        if(typeof window.psiTrack==='function')window.psiTrack('box_configurator_add',{pezzi:pezzi});
      }catch(error){status.textContent=labels.cartError;cartButton.disabled=false;cartButton.textContent=labels.cartAdd;}
    }
    root.addEventListener('click',function(event){
      /* v438 — COME NIKE BY YOU: toccare una scelta aggiorna la foto e RESTA nel passo.
         Si va avanti con la freccia destra o con Continua. Prima ogni tocco saltava al
         passo successivo, quindi la scelta non si vedeva nemmeno.
         L'unica eccezione e' il clic non fidato (event.isTrusted false), cioe' quello
         che psi-box-deeplink genera da codice arrivando dalle pagine Box: la' la
         sequenza deve scorrere fino alle taglie da sola, come prima. */
      var color=event.target.closest('[data-action="color"]');if(color){state.color=color.dataset.value;segnaScelta('color',state.color);setViewer(color.dataset.image,state.color);var tc=root.querySelector('[data-color-title]');if(tc)tc.textContent=state.color;renderModels();aggiorna(event,'model');return;}
      var model=event.target.closest('[data-action="model"]');if(model){state.model=data.find(function(item){return item.key===model.dataset.value;});segnaScelta('model',model.dataset.value);setViewer(model.dataset.image,state.model.name+' '+state.color);var tm=root.querySelector('[data-model-title]');if(tm)tm.textContent=state.model.name;renderCompositions();aggiorna(event,'composition');return;}
      var composition=event.target.closest('[data-action="composition"]');if(composition){state.variant=state.model.variants.find(function(item){return item.sku===composition.dataset.value;});segnaScelta('composition',composition.dataset.value);setViewer(composition.dataset.image,state.model.name+' '+state.color+' '+state.variant.composition);var tk=root.querySelector('[data-composition-title]');if(tk)tk.textContent='Composizione '+state.variant.composition+' · '+money(state.variant.price);renderComponents();aggiorna(event,'sizes');return;}
      var back=event.target.closest('[data-back]');if(back){setStage(back.dataset.back);return;}
      var select=event.target.closest('[data-select-sku]');if(select){var component=state.variant.components.find(function(item){return item.sku===select.dataset.selectSku;});if(component)openSizes(component);}
    });
    /* Frecce della barra. Nessuna logica nuova: la sinistra clicca il [data-back] del
       passo, la destra riclicca la scelta gia' fatta, che e' esattamente cio' che
       porta avanti il configuratore. Cosi' anche il deeplink continua a passare per
       la stessa strada. */
    if(navPrev)navPrev.addEventListener('click',function(){
      var back=root.querySelector('[data-stage="'+stageCorrente+'"] [data-back]');
      if(back)back.click();
    });
    /* v441 — TENDINA TRASCINABILE.
       Due sole altezze, decise dal CSS: normale e alzata. Qui si cambia solo la classe.
       Al passo taglie si apre gia' alzata, ma non del tutto: sopra resta meta' foto,
       cosi' si vede sempre che cosa si sta configurando. */
    var sheet=root;
    /* v443 — TRE LIVELLI, non due:
         0 normale  — la misura dei passi 1-3
         1 alzata   — meta' foto sopra
         2 tutta    — resta solo la riga con "..." e Fine, cosi' entrano piu' capi
                      e si scorre il meno possibile
       Al passo taglie si parte da 2. L'utente puo' sempre riabbassarla trascinando
       la testa della barra. */
    var livello=0;
    function poni(n){
      livello=Math.max(0,Math.min(2,n));
      sheet.classList.toggle('is-expanded',livello===1);
      sheet.classList.toggle('is-full',livello===2);
    }
    function alza(si){poni(si?livello+1:livello-1);}
    /* v444 — TRASCINAMENTO FLUIDO.
       Prima il dito non muoveva niente: superati 36px la tendina saltava di scatto a
       un altro livello, quindi o non si abbassava o si abbassava troppo.
       Ora la barra segue il dito in tempo reale (altezza scritta in linea, transizione
       spenta durante il gesto) e al rilascio si accosta da sola all'altezza piu'
       vicina fra le tre. Le tre altezze si ricalcolano dalla finestra, cosi' valgono
       su qualunque telefono. */
    var bar=root.querySelector('.psibox__bar');
    function altezze(){
      var H=window.innerHeight;
      return [Math.min(Math.max(300,H*0.46),430), Math.min(H*0.66,640), H-66];
    }
    var head=root.querySelector('[data-bar-head]');
    if(head&&bar){
      var y0=null,h0=0,mosso=false,daManiglia=false;
      head.addEventListener('pointerdown',function(e){
        y0=e.clientY;h0=bar.getBoundingClientRect().height;mosso=false;
        daManiglia=!!e.target.closest('.psibox__bar-grip,.psibox__nav-title');
        head.setPointerCapture&&head.setPointerCapture(e.pointerId);
      });
      head.addEventListener('pointermove',function(e){
        if(y0===null)return;
        var dy=y0-e.clientY;
        if(!mosso&&Math.abs(dy)<6)return;
        mosso=true;
        var L=altezze();
        var h=Math.max(L[0]-60,Math.min(L[2],h0+dy));
        bar.style.transition='none';
        bar.style.height=h+'px';
      });
      function rilascia(){
        if(y0===null)return;
        y0=null;
        if(!mosso){if(daManiglia)poni(livello>=2?0:livello+1);return;}
        var L=altezze(),h=bar.getBoundingClientRect().height;
        var vicino=0,d=Infinity;
        L.forEach(function(v,i){var q=Math.abs(v-h);if(q<d){d=q;vicino=i;}});
        bar.style.transition='';bar.style.height='';
        poni(vicino);
      }
      head.addEventListener('pointerup',rilascia);
      head.addEventListener('pointercancel',rilascia);
    }
    window.addEventListener('resize',function(){normalizza(viewerImage&&viewerImage.getAttribute('src'));});
    function avanti(){
      var passo=ORDINE[ORDINE.indexOf(stageCorrente)+1];
      if(passo)setStage(passo);
    }
    if(navNext)navNext.addEventListener('click',avanti);
    var goBtn=root.querySelector('[data-nav-continue]');
    if(goBtn)goBtn.addEventListener('click',avanti);
    /* "Fine": chiude il configuratore e riporta alla card BOX. Non tocca lo stato,
       quindi riaprendolo si ritrova la configurazione dov'era. */
    /* v436 — il configuratore vive su una pagina sua a schermo pieno, quindi "Fine"
       esce dalla pagina. Se il visitatore e' arrivato da Grandi Forniture torna
       indietro nella cronologia (ritrova la posizione di scorrimento); altrimenti va
       all'indirizzo di Grandi Forniture. */
    /* v453 — FINE.
       Prima provava a tornare indietro nella cronologia quando il visitatore arrivava
       dal sito: e' li' che a volte non funzionava, perche' la pagina precedente poteva
       non essere Grandi Forniture (o non esserci affatto, se il link era stato aperto
       da fuori). Ora va sempre all'indirizzo di Grandi Forniture: prevedibile.
       E se qualcosa e' gia' stato scelto, prima chiede. */
    var leaveDialog=root.querySelector('[data-leave-dialog]');
    var leaveText=root.querySelector('[data-leave-text]');
    function scelteFatte(){
      var n=0;
      if(state.color)n++;
      if(state.model)n++;
      if(state.variant)n++;
      Object.keys(state.selections||{}).forEach(function(sku){
        var q=state.selections[sku]||{};
        if(Object.keys(q).some(function(k){return Number(q[k])>0;}))n++;
      });
      return n;
    }
    function esci(){window.location.href=root.dataset.exitUrl||'/';}
    if(doneButton)doneButton.addEventListener('click',function(){
      var n=scelteFatte();
      if(!n||!leaveDialog){esci();return;}
      if(leaveText)leaveText.textContent=n===1
        ? 'Hai gia\u2019 fatto una scelta: uscendo la perdi.'
        : 'Hai gia\u2019 fatto '+n+' scelte: uscendo le perdi.';
      leaveDialog.showModal();
      var x=leaveDialog.querySelector('[data-leave-stay]');if(x&&x.blur)x.blur();
    });
    if(leaveDialog){
      var stay=leaveDialog.querySelector('[data-leave-stay]');
      var go=leaveDialog.querySelector('[data-leave-go]');
      if(stay)stay.addEventListener('click',function(){leaveDialog.close();});
      if(go)go.addEventListener('click',esci);
      leaveDialog.addEventListener('click',function(e){if(e.target===leaveDialog)leaveDialog.close();});
    }
    root.querySelector('[data-apply-sizes]').addEventListener('click',applySizes);
    cartButton.addEventListener('click',addToCart);
    printButton.addEventListener('click',function(){if(!draft()){status.textContent='Completa prima la configurazione.';return;}window.print();if(typeof window.psiTrack==='function')window.psiTrack('box_configurator_print',{});});
    renderColors();
    /* v435 — la barra parte impostata: senza questa chiamata titolo e contatore
       restano vuoti finche' non si tocca qualcosa. */
    setStage('color');
    var restored=false;
    try{
      var hash=new URLSearchParams(window.location.hash.slice(1)).get('box');
      if(hash)restored=restoreDraft(JSON.parse(hash));
      if(!restored&&storageAllowed()){var saved=localStorage.getItem('psi_box_draft_v1');if(saved)restoreDraft(JSON.parse(saved));}
    }catch(error){}
  }
  document.querySelectorAll('[data-psi-box]').forEach(init);
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psi-complete-look"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(root){
    if(root.dataset.lookReady)return;root.dataset.lookReady='true';
    const track=root.querySelector('.psi-look-track'),dialog=root.querySelector('dialog');
    if(!track||!dialog)return;
    // Generate each outfit from available candidates, matching the anchor palette.
    // The product pool is rendered by Liquid, so prices/links/stock remain Shopify's.
    const cards=Array.from(track.children);let visit=0;
    const rotate=root.dataset.lookRotation==='true'&&!window.Shopify?.designMode;
    if(rotate){
      if(window.psiLookVisitV4===undefined){
        try{const n=Number(sessionStorage.getItem('psi-look-visit-v4')||0);window.psiLookVisitV4=Number.isSafeInteger(n)&&n>=0?n:0;sessionStorage.setItem('psi-look-visit-v4',String((window.psiLookVisitV4+1)%600));}
        catch(e){window.psiLookVisitV4=Math.floor(Date.now()/86400000);}
      }
      visit=window.psiLookVisitV4;
    }
    const affinity=(tone,anchor)=>tone===anchor?3:(tone==='black'||tone==='white'||tone==='equipment'?1:0);
    cards.forEach(card=>{
      const pool=Array.from(card.querySelectorAll('template[data-look-slot]'));
      const slots=[...new Set(pool.map(t=>t.dataset.lookSlot))];let anchor='';const selected=[];
      for(const slot of slots){
        const candidates=pool.filter(t=>t.dataset.lookSlot===slot);
        const best=anchor?Math.max(...candidates.map(t=>affinity(t.dataset.lookTone,anchor))):3;
        const matches=anchor?candidates.filter(t=>affinity(t.dataset.lookTone,anchor)===best&&best>0):candidates;
        if(!matches.length){card.hidden=true;return;}
        const chosen=matches[(visit+Number(slot)-1)%matches.length];
        if(!anchor)anchor=chosen.dataset.lookTone;
        selected.push(chosen);
      }
      if(selected.length!==Number(card.dataset.lookSlots)){card.hidden=true;return;}
      const canvas=card.querySelector('.psi-look-canvas'),eye=canvas.querySelector('.psi-look-all');
      canvas.querySelectorAll('.psi-look-piece,.psi-look-popup').forEach(e=>e.remove());
      selected.forEach(t=>canvas.insertBefore(t.content.cloneNode(true),eye));
      card.dataset.lookPalette=anchor;
    });
    const visible=cards.filter(c=>!c.hidden);
    if(rotate&&visible.length){const offset=visit%visible.length;visible.slice(offset).concat(visible.slice(0,offset)).forEach(c=>track.append(c));}
    if(!visible.length){root.hidden=true;return;}
    const closePopups=()=>{root.querySelectorAll('.psi-look-popup').forEach(x=>x.hidden=true);root.querySelectorAll('.psi-look-hotspot').forEach(x=>x.setAttribute('aria-expanded','false'));};
    function updateArrows(){root.querySelector('[data-look-direction="-1"]').disabled=track.scrollLeft<2;root.querySelector('[data-look-direction="1"]').disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;}
    let previousFocus=null;
    function openLook(card,trigger){
      closePopups();const items=dialog.querySelector('.psi-look-dialog-items');items.replaceChildren();
      card.querySelectorAll('.psi-look-popup').forEach(link=>{
        const row=document.createElement('article');row.className='psi-look-sheet-item';
        const photo=document.createElement('a');photo.href=link.href;photo.className='psi-look-sheet-photo';photo.tabIndex=-1;photo.setAttribute('aria-hidden','true');
        const img=document.createElement('img');img.src=link.dataset.lookPhoto;img.alt='';img.width=240;img.height=300;img.decoding='async';photo.append(img);
        const info=document.createElement('div');info.className='psi-look-sheet-info';
        const title=document.createElement('h3');title.textContent=link.querySelector('strong').textContent;
        const type=document.createElement('p');type.textContent=link.dataset.lookType;
        const price=document.createElement('b');price.textContent=link.querySelector('b').textContent;
        const buy=document.createElement('a');buy.className='psi-look-buy';buy.href=link.href;buy.textContent=link.dataset.lookBuy;buy.setAttribute('aria-label',buy.textContent+' '+title.textContent);
        info.append(title,type,price,buy);row.append(photo,info);items.append(row);
      });
      previousFocus=trigger;document.body.classList.add('psi-look-open');dialog.showModal();
    }
    root.addEventListener('click',event=>{
      const hot=event.target.closest('.psi-look-hotspot');
      if(hot){const open=hot.getAttribute('aria-expanded')==='true';closePopups();if(!open){hot.setAttribute('aria-expanded','true');document.getElementById(hot.getAttribute('aria-controls')).hidden=false;}return;}
      const arrow=event.target.closest('[data-look-direction]');
      if(arrow){const first=Array.from(track.children).find(c=>!c.hidden),gap=parseFloat(getComputedStyle(track).columnGap)||0;track.scrollBy({left:Number(arrow.dataset.lookDirection)*((first?.getBoundingClientRect().width||track.clientWidth)+gap),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});return;}
      const all=event.target.closest('.psi-look-all');if(all)openLook(all.closest('.psi-look-card'),all);
    });
    dialog.addEventListener('click',e=>{if(e.target.closest('.psi-look-close'))dialog.close();else if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
    dialog.addEventListener('close',()=>{document.body.classList.remove('psi-look-open');previousFocus?.focus({preventScroll:true});});
    document.addEventListener('click',e=>{if(!e.target.closest('.psi-look-hotspot,.psi-look-popup'))closePopups();});
    root.addEventListener('keydown',e=>{if(e.key==='Escape')closePopups();});
    track.addEventListener('scroll',()=>{closePopups();updateArrows();},{passive:true});new ResizeObserver(updateArrows).observe(track);updateArrows();
  }
  document.querySelectorAll('.psi-complete-look').forEach(setup);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.psi-complete-look').forEach(setup));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psi-help-center"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(){
var root=document.querySelector('[data-help-center]');if(!root||root.dataset.ready)return;root.dataset.ready='true';
var input=root.querySelector('#ph-search'),form=root.querySelector('.ph-search'),status=root.querySelector('.ph-search-status'),articles=Array.from(root.querySelectorAll('[data-help-article]')),empty=root.querySelector('.ph-empty');
var normalize=function(s){return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[’']/g,' ');};
var index=articles.map(function(el){return {el:el,text:normalize(el.textContent+' '+el.dataset.keywords)};});
function corporateView(on){root.classList.toggle('ph-corporate-view',on);articles.forEach(function(el){el.hidden=on&&el.id!=='info-legali-societarie';});root.querySelector('.ph-quick').hidden=on;root.querySelector('.ph-contact').hidden=on;empty.hidden=true;}
function search(){corporateView(false);var words=normalize(input.value).trim().split(/\s+/).filter(Boolean),count=0;index.forEach(function(item){var match=words.every(function(word){return item.text.includes(word);});item.el.hidden=!match;if(words.length)item.el.open=match;else item.el.open=false;if(match)count++;});root.querySelector('.ph-quick').hidden=words.length>0;root.querySelector('.ph-contact').hidden=words.length>0;empty.hidden=!words.length||count>0;status.textContent=words.length?status.dataset.resultsLabel+': '+count:'';}
input.addEventListener('input',search);
form.addEventListener('submit',function(e){e.preventDefault();search();root.querySelector('.ph-articles').scrollIntoView({block:'start'});});
function openTarget(hash,focus){var id;try{id=decodeURIComponent((hash||'').replace(/^#/,''));}catch(e){return;}if(!id)return;var target=document.getElementById(id);if(!target||!root.contains(target))return;if(input.value){input.value='';search();}corporateView(id==='info-legali-societarie');if(id==='info-legali-societarie'){target.open=true;window.scrollTo({top:0,behavior:'instant'});if(focus){var title=target.querySelector('h2');title.setAttribute('tabindex','-1');title.focus({preventScroll:true});}return;}if(target.matches('details'))target.open=true;var parent=target.parentElement.closest('details');if(parent)parent.open=true;requestAnimationFrame(function(){target.scrollIntoView({block:'start'});if(focus){var el=target.querySelector('summary')||target;el.setAttribute('tabindex','-1');el.focus({preventScroll:true});}});}
document.addEventListener('click',function(e){var a=e.target.closest('a[href]');if(!a||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;var url=new URL(a.href,location.href);if(url.origin===location.origin&&url.pathname===location.pathname&&url.hash&&document.getElementById(url.hash.slice(1))){e.preventDefault();history.pushState(null,'',url.hash);openTarget(url.hash,true);}});
window.addEventListener('hashchange',function(){openTarget(location.hash,false);});
var result=root.querySelector('[data-form-result]');if(result){openTarget('#scrivici',false);}else if(location.hash){openTarget(location.hash,false);}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
